module.exports = __webpack_public_path__ + "static/media/435944788_948380830631626_1768233232901618823_n.d1d01796.jpg";